/**
 * Custom Candle 3D Preview Integration
 * Handles 3D preview functionality for the custom candle builder
 * This module extends VisualPreviewGenerator with 3D preview capabilities
 */

(function () {
	"use strict";

	// Wait for VisualPreviewGenerator to be available
	function initialize3DPreview() {
		if (typeof VisualPreviewGenerator === "undefined") {
			// Retry after a short delay (max 5 seconds)
			if (initialize3DPreview.attempts === undefined) {
				initialize3DPreview.attempts = 0;
			}
			initialize3DPreview.attempts++;
			if (initialize3DPreview.attempts < 50) {
				setTimeout(initialize3DPreview, 100);
			} else {
				console.error(
					"VisualPreviewGenerator class not found after 5 seconds. Make sure CustomCandleClass.js is loaded."
				);
			}
			return;
		}

		// VisualPreviewGenerator is now available, proceed with initialization
		setup3DPreview();
	}

	function setup3DPreview() {
		/**
		 * Calculate the total height of fixed header elements
		 */
		VisualPreviewGenerator.prototype.calculateHeaderHeight = function () {
			// Fixed header height of 64px
			const headerHeight = 64;
			console.log("📐 Header height:", headerHeight);
			return headerHeight;
		};

		/**
		 * Initialize 3D preview properties on VisualPreviewGenerator
		 */
		VisualPreviewGenerator.prototype.init3DProperties = function () {
			this.threeDPreview = null; // Will hold the ThreeDCandlePreview instance
			this.is3DMode = true; // Default to 3D mode
			this.currentTypeColor = "#000000"; // Store current type color
			console.log(
				"🎨 init3DProperties called, is3DMode set to:",
				this.is3DMode
			);
		};

		/**
		 * Initialize 3D preview if Three.js is available
		 */
		VisualPreviewGenerator.prototype.init3DPreview = function (
			canvasElement,
			typeColor
		) {
			console.log("🎨 init3DPreview called");
			console.log("🎨 Canvas element:", canvasElement);
			console.log("🎨 Type color:", typeColor);
			console.log(
				"🎨 Canvas dimensions:",
				canvasElement?.width,
				"x",
				canvasElement?.height
			);

			// Check if libraries are loaded
			console.log("🎨 THREE defined:", typeof THREE !== "undefined");
			console.log(
				"🎨 ThreeDCandlePreview defined:",
				typeof ThreeDCandlePreview !== "undefined"
			);

			if (
				typeof THREE === "undefined" ||
				typeof ThreeDCandlePreview === "undefined"
			) {
				console.log(
					"⏳ Three.js or ThreeDCandlePreview not loaded yet (will retry)"
				);
				return false;
			}

			// Find or create container for 3D preview
			let container3D = this.el.querySelector("#three-d-preview-container");
			// Also search document-wide if not found in this.el
			if (!container3D) {
				container3D = document.querySelector("#three-d-preview-container");
			}
			console.log("🎨 Existing container:", container3D);

			if (!container3D) {
				console.log("🎨 Creating new 3D container...");
				container3D = document.createElement("div");
				container3D.id = "three-d-preview-container";
				container3D.style.width = "100%";
				// Calculate height to fill viewport minus fixed header
				const headerHeight = this.calculateHeaderHeight();
				container3D.style.height = `calc(100vh - ${headerHeight}px)`;
				container3D.style.display = "block"; // Make visible immediately
				// Ensure it starts hidden for fade-in effect
				container3D.classList.remove("loaded");

				// Try multiple insertion strategies for reliability
				const cardPreview = this.el.querySelector("#card-preview");
				const previewWrapper =
					this.el.querySelector("#custom-candle-preview__wrapper") ||
					document.querySelector("#custom-candle-preview__wrapper");

				console.log("🎨 Card preview for insertion:", cardPreview);
				console.log("🎨 Preview wrapper for insertion:", previewWrapper);

				// Strategy 1: Insert in preview wrapper if it exists
				if (previewWrapper) {
					previewWrapper.insertBefore(container3D, previewWrapper.firstChild);
					console.log("✅ 3D container inserted into preview wrapper");
				}
				// Strategy 2: Insert after card-preview
				else if (cardPreview && cardPreview.parentNode) {
					cardPreview.parentNode.insertBefore(
						container3D,
						cardPreview.nextSibling
					);
					console.log("✅ 3D container inserted after card-preview");
				}
				// Strategy 3: Insert into this.el directly
				else if (this.el) {
					this.el.appendChild(container3D);
					console.log("✅ 3D container appended to this.el");
				} else {
					console.error(
						"❌ Cannot insert container - no suitable parent found"
					);
					return false;
				}
			}

			console.log("🎨 Creating ThreeDCandlePreview instance...");
			console.log(
				"🎨 Container dimensions:",
				container3D.clientWidth,
				"x",
				container3D.clientHeight
			);

			try {
				this.threeDPreview = new ThreeDCandlePreview(
					container3D,
					canvasElement
				);

				// Set the type color if provided
				if (typeColor) {
					this.threeDPreview.typeColor = typeColor;
					console.log("✅ Type color set to:", typeColor);
				}

				console.log(
					"✅ ThreeDCandlePreview instance created:",
					this.threeDPreview
				);

				// Ensure container is visible before initializing
				if (container3D) {
					// Update container height before showing
					const headerHeight = this.calculateHeaderHeight();
					container3D.style.height = `calc(100vh - ${headerHeight}px)`;
					container3D.style.display = "block";
					// Remove loaded class to start with opacity 0 (for fade-in effect)
					container3D.classList.remove("loaded");
					console.log(
						"✅ Container made visible before init (opacity 0, will fade in)"
					);
				}

				console.log("🎨 Calling init() on 3D preview...");
				// init() is async, but we don't need to await it
				// The initialization will complete and render automatically
				this.threeDPreview
					.init()
					.then(() => {
						console.log("✅ 3D preview initialized successfully!");
						// Ensure container is still visible after initialization
						if (container3D) {
							container3D.style.display = "block";
							// Fade in the container after initialization
							// Use requestAnimationFrame to ensure display is set before fade
							requestAnimationFrame(() => {
								container3D.classList.add("loaded");
								console.log("✅ 3D preview faded in");
							});
							console.log("✅ Container confirmed visible after async init");
						}
					})
					.catch((error) => {
						console.error("❌ Error during async 3D preview init:", error);
					});

				return true;
			} catch (error) {
				console.error("❌ Error initializing 3D preview:", error);
				return false;
			}
		};

		/**
		 * Toggle between 2D and 3D preview
		 */
		VisualPreviewGenerator.prototype.toggle3DPreview = function (enable) {
			console.log("🎨 toggle3DPreview called with enable =", enable);
			console.log("🎨 this.el:", this.el);

			// Try to find card-preview in this.el, or search document-wide
			let cardPreview = this.el.querySelector("#card-preview");
			if (!cardPreview) {
				cardPreview = document.querySelector("#card-preview");
			}
			console.log("🎨 Card preview element:", cardPreview);

			// Try to find 3D container in this.el, or search document-wide
			let container3D = this.el.querySelector("#three-d-preview-container");
			if (!container3D) {
				container3D = document.querySelector("#three-d-preview-container");
			}
			console.log("🎨 3D container (before check):", container3D);

			// Create container if it doesn't exist
			if (!container3D) {
				console.log("🎨 Creating 3D container...");
				container3D = document.createElement("div");
				container3D.id = "three-d-preview-container";
				container3D.style.width = "100%";
				// Calculate height to fill viewport minus fixed header
				const headerHeight = this.calculateHeaderHeight();
				container3D.style.height = `calc(100vh - ${headerHeight}px)`;
				container3D.style.display = "none";

				// Try multiple insertion strategies for reliability
				const previewWrapper =
					this.el.querySelector("#custom-candle-preview__wrapper") ||
					document.querySelector("#custom-candle-preview__wrapper");

				// Strategy 1: Insert in preview wrapper if it exists
				if (previewWrapper) {
					previewWrapper.insertBefore(container3D, previewWrapper.firstChild);
					console.log("✅ 3D container inserted into preview wrapper");
				}
				// Strategy 2: Insert after card-preview
				else if (cardPreview && cardPreview.parentNode) {
					cardPreview.parentNode.insertBefore(
						container3D,
						cardPreview.nextSibling
					);
					console.log("✅ 3D container inserted after card-preview");
				}
				// Strategy 3: Insert into this.el directly
				else if (this.el) {
					this.el.appendChild(container3D);
					console.log("✅ 3D container appended to this.el");
				} else {
					console.error(
						"❌ Cannot insert 3D container - no suitable parent found"
					);
					return;
				}
			}

			this.is3DMode = enable;
			console.log("🎨 is3DMode set to:", this.is3DMode);

			if (enable) {
				// Show 3D, hide 2D
				if (cardPreview) {
					cardPreview.style.display = "none";
					console.log("🎨 2D preview hidden");
				}
				// Update container height before showing (in case header state changed)
				const headerHeight = this.calculateHeaderHeight();
				container3D.style.height = `calc(100vh - ${headerHeight}px)`;
				container3D.style.display = "block";
				// If 3D preview already exists, fade it in
				if (this.threeDPreview) {
					requestAnimationFrame(() => {
						container3D.classList.add("loaded");
					});
				}
				console.log("🎨 3D container shown");

				// Initialize 3D preview if not already done
				if (!this.threeDPreview) {
					console.log("🎨 Initializing 3D preview for first time...");

					// Wait for Three.js and ThreeDCandlePreview to be available
					this.waitForThreeJSThenInit(container3D);
					return; // Exit early, initialization will happen asynchronously
				} else {
					console.log("🎨 3D preview already exists, updating texture...");
					// Get the current type color from the selected color option
					let selectedColorOption = this.el.querySelector(
						".customizer-label-color-option-selected"
					);
					// Fallback to document-wide search if not found in this.el
					if (!selectedColorOption) {
						selectedColorOption = document.querySelector(
							".customizer-label-color-option-selected"
						);
					}
					const currentColor = selectedColorOption
						? selectedColorOption.getAttribute("data-typecolor")
						: this.currentTypeColor;
					console.log("🎨 Selected color option:", selectedColorOption);
					console.log("🎨 Current type color for update:", currentColor);
					// Update texture with current canvas and color
					this.update3DTexture(currentColor);
				}
			} else {
				// Show 2D, hide 3D
				if (cardPreview) {
					cardPreview.style.display = "";
					console.log("🎨 2D preview shown");
				}
				container3D.style.display = "none";
				console.log("🎨 3D container hidden");
			}

			console.log("🎨 Toggle complete. Final state:", {
				is3DMode: this.is3DMode,
				has3DPreview: !!this.threeDPreview,
				containerDisplay: container3D.style.display,
			});
		};

		/**
		 * Update the 3D preview texture
		 */
		VisualPreviewGenerator.prototype.update3DTexture = function (typeColor) {
			if (this.threeDPreview) {
				if (typeColor) {
					this.threeDPreview.typeColor = typeColor;
				}
				this.threeDPreview.updateTexture();
			}
		};

		// Override renderVisualPreviewWithCanvas to add 3D preview initialization
		const originalRenderVisualPreviewWithCanvas =
			VisualPreviewGenerator.prototype.renderVisualPreviewWithCanvas;

		VisualPreviewGenerator.prototype.renderVisualPreviewWithCanvas = function (
			properties
		) {
			// Initialize 3D properties if not already done
			if (this.threeDPreview === undefined) {
				this.init3DProperties();
			}

			// Ensure is3DMode is true by default (force it if somehow it got set to false)
			if (this.is3DMode !== true) {
				console.log("🎨 Warning: is3DMode was not true, forcing it to true");
				this.is3DMode = true;
			}

			console.log(
				"🎨 renderVisualPreviewWithCanvas called, is3DMode:",
				this.is3DMode,
				"has3DPreview:",
				!!this.threeDPreview
			);

			// Store the current type color before canvas update
			if (properties && properties.typeColor) {
				this.currentTypeColor = properties.typeColor;
			}

			// If in 3D mode and preview exists, ensure canvas stays hidden during update
			const cardPreview = this.el.querySelector("#card-preview");
			const wasHidden = cardPreview && cardPreview.style.display === "none";

			if (this.is3DMode && this.threeDPreview && cardPreview) {
				// Force hide canvas before update to prevent any visible flicker
				cardPreview.style.display = "none";
			}

			// Call original method to update canvas (this happens synchronously)
			originalRenderVisualPreviewWithCanvas.call(this, properties);

			// If in 3D mode and 3D preview already exists, update texture
			if (this.is3DMode && this.threeDPreview) {
				// Update texture - it will read from the just-updated canvas
				// The texture update is async (due to logo loading), but that's OK
				// The canvas is already hidden, so no flicker should be visible
				// Always update texture when canvas changes (e.g., fragrance changes)
				// Use typeColor from properties if available, otherwise use stored currentTypeColor
				const typeColorToUse =
					(properties && properties.typeColor) || this.currentTypeColor;
				console.log("🎨 Updating 3D texture (canvas is hidden, no flicker)", {
					hasTypeColor: !!(properties && properties.typeColor),
					typeColor: typeColorToUse,
				});
				this.update3DTexture(typeColorToUse);

				// Ensure canvas stays hidden after update
				if (cardPreview) {
					cardPreview.style.display = "none";
				}
			} else if (this.is3DMode && !this.threeDPreview) {
				// Initialize in 3D mode by default after canvas is rendered
				console.log(
					"🎨 Initializing in 3D mode by default, calling waitForThreeJSAndToggle"
				);
				// Ensure canvas is hidden before initializing 3D
				if (cardPreview) {
					cardPreview.style.display = "none";
				}
				// Wait for Three.js to be available before toggling
				this.waitForThreeJSAndToggle();
			} else {
				// This branch should not happen if is3DMode is true
				console.log(
					"🎨 Not initializing 3D mode, is3DMode is:",
					this.is3DMode,
					"has3DPreview:",
					!!this.threeDPreview
				);
				// Only restore canvas visibility if we're actually in 2D mode
				if (!this.is3DMode && !wasHidden && cardPreview) {
					cardPreview.style.display = "";
				}
			}
		};

		/**
		 * Wait for Three.js to load, then toggle to 3D mode
		 */
		VisualPreviewGenerator.prototype.waitForThreeJSAndToggle = function () {
			console.log("🎨 waitForThreeJSAndToggle called");
			console.log("🎨 THREE available:", typeof THREE !== "undefined");
			console.log(
				"🎨 ThreeDCandlePreview available:",
				typeof ThreeDCandlePreview !== "undefined"
			);

			const maxAttempts = 100; // 10 seconds max wait
			let attempts = 0;
			let toggled = false; // Prevent multiple toggles

			const doToggle = () => {
				if (toggled) {
					console.log("🎨 Already toggled, skipping");
					return;
				}
				toggled = true;
				console.log(
					"✅ Three.js and ThreeDCandlePreview available, toggling to 3D"
				);
				// Small delay to ensure canvas is fully rendered
				setTimeout(() => {
					this.toggle3DPreview(true);
				}, 300);
			};

			const checkAndToggle = () => {
				attempts++;

				if (
					typeof THREE !== "undefined" &&
					typeof ThreeDCandlePreview !== "undefined"
				) {
					doToggle();
					return;
				}

				if (attempts < maxAttempts) {
					// Check again in 100ms
					setTimeout(checkAndToggle, 100);
				} else {
					console.warn(
						"⚠️ Three.js not loaded after 10 seconds, 3D preview unavailable"
					);
					console.log("THREE available:", typeof THREE !== "undefined");
					console.log(
						"ThreeDCandlePreview available:",
						typeof ThreeDCandlePreview !== "undefined"
					);
				}
			};

			// Also listen for the threejs-loaded event
			const eventHandler = () => {
				console.log("✅ Received threejs-loaded event, toggling to 3D");
				doToggle();
				document.removeEventListener("threejs-loaded", eventHandler);
			};
			document.addEventListener("threejs-loaded", eventHandler);

			// Start checking
			checkAndToggle();
		};

		/**
		 * Wait for Three.js to load, then initialize 3D preview
		 */
		VisualPreviewGenerator.prototype.waitForThreeJSThenInit = function (
			container3D
		) {
			console.log("🎨 waitForThreeJSThenInit called");

			const maxAttempts = 100; // 10 seconds max wait
			let attempts = 0;
			let initialized = false;

			const doInit = () => {
				if (initialized) {
					console.log("🎨 Already initialized, skipping");
					return;
				}
				initialized = true;

				const canvasFront = document.getElementById("canvas-front");
				console.log("🎨 Canvas element:", canvasFront);

				// Get the current type color from the selected color option
				let selectedColorOption = this.el.querySelector(
					".customizer-label-color-option-selected"
				);
				// Fallback to document-wide search if not found in this.el
				if (!selectedColorOption) {
					selectedColorOption = document.querySelector(
						".customizer-label-color-option-selected"
					);
				}
				const currentColor = selectedColorOption
					? selectedColorOption.getAttribute("data-typecolor")
					: this.currentTypeColor;
				console.log("🎨 Selected color option:", selectedColorOption);
				console.log("🎨 Current type color:", currentColor);

				if (canvasFront) {
					// Ensure container is visible before initializing
					if (container3D) {
						// Update container height before showing
						const headerHeight = this.calculateHeaderHeight();
						container3D.style.height = `calc(100vh - ${headerHeight}px)`;
						container3D.style.display = "block";
						// Remove loaded class to start with opacity 0 (for fade-in effect)
						container3D.classList.remove("loaded");
						console.log(
							"🎨 Container made visible before init (opacity 0, will fade in)"
						);
					}
					const success = this.init3DPreview(canvasFront, currentColor);
					console.log("🎨 3D preview init result:", success);
					console.log("🎨 threeDPreview after init:", this.threeDPreview);

					// If initialization succeeded, ensure container is visible
					if (success && container3D) {
						container3D.style.display = "block";
						// The fade-in will be triggered by the init() promise in init3DPreview
						console.log("✅ Container confirmed visible after successful init");
					}
				} else {
					console.error("❌ Canvas not found - cannot initialize 3D preview");
				}
			};

			const checkAndInit = () => {
				attempts++;

				if (
					typeof THREE !== "undefined" &&
					typeof ThreeDCandlePreview !== "undefined"
				) {
					console.log(
						"✅ Three.js and ThreeDCandlePreview available, initializing 3D preview"
					);
					setTimeout(doInit, 100); // Small delay to ensure everything is ready
					return;
				}

				if (attempts < maxAttempts) {
					// Check again in 100ms
					setTimeout(checkAndInit, 100);
				} else {
					console.warn(
						"⚠️ Three.js not loaded after 10 seconds, 3D preview unavailable"
					);
					console.log("THREE available:", typeof THREE !== "undefined");
					console.log(
						"ThreeDCandlePreview available:",
						typeof ThreeDCandlePreview !== "undefined"
					);
				}
			};

			// Also listen for the threejs-loaded event
			const eventHandler = () => {
				console.log(
					"✅ Received threejs-loaded event, initializing 3D preview"
				);
				doInit();
				document.removeEventListener("threejs-loaded", eventHandler);
			};
			document.addEventListener("threejs-loaded", eventHandler);

			// Start checking
			checkAndInit();
		};

		// Make instance available globally for toggle button
		window.currentVisualPreviewInstance = null;

		// Hook into CustomCandleClass to set the global instance
		// Use a function that will be called when CustomCandleClass is available
		function hookIntoCustomCandleClass() {
			if (typeof CustomCandleClass !== "undefined") {
				const originalCandlePreviewEvent =
					CustomCandleClass.prototype.candlePreviewEvent;
				CustomCandleClass.prototype.candlePreviewEvent = function (e) {
					const result = originalCandlePreviewEvent.call(this, e);

					// Set global instance reference after visualPreview is created
					if (this.visualPreview) {
						window.currentVisualPreviewInstance = this.visualPreview;
						console.log(
							"✅ VisualPreviewGenerator instance set globally:",
							window.currentVisualPreviewInstance
						);
					}

					return result;
				};

				// Also hook into constructor to set instance early
				const originalConstructor = CustomCandleClass.prototype.constructor;

				return true;
			}
			return false;
		}

		// Try immediately
		if (!hookIntoCustomCandleClass()) {
			// If CustomCandleClass isn't loaded yet, wait for it
			if (document.readyState === "loading") {
				document.addEventListener(
					"DOMContentLoaded",
					hookIntoCustomCandleClass
				);
			} else {
				// DOM already loaded, try after a short delay
				setTimeout(hookIntoCustomCandleClass, 100);
			}
		}

		// Also try to find instance from existing CustomCandleClass instances
		function findExistingInstance() {
			// Try to find the customCandleBuilder global instance
			if (
				typeof customCandleBuilder !== "undefined" &&
				customCandleBuilder.visualPreview
			) {
				window.currentVisualPreviewInstance = customCandleBuilder.visualPreview;
				console.log(
					"✅ Found existing VisualPreviewGenerator instance from customCandleBuilder"
				);
				return true;
			}
			return false;
		}

		// Try to find existing instance after a delay
		setTimeout(() => {
			if (!window.currentVisualPreviewInstance) {
				findExistingInstance();
			}
		}, 1000);

		// Also try to find instance whenever candlePreviewEvent is called
		// This ensures we catch it even if the hook wasn't set up in time
		const checkForInstance = setInterval(() => {
			if (typeof customCandleBuilder !== "undefined") {
				if (customCandleBuilder.visualPreview) {
					if (!window.currentVisualPreviewInstance) {
						window.currentVisualPreviewInstance =
							customCandleBuilder.visualPreview;
						console.log(
							"✅ Found VisualPreviewGenerator instance from customCandleBuilder (polling)"
						);
					}
					clearInterval(checkForInstance);
				}
			}
		}, 500);

		// Stop checking after 10 seconds
		setTimeout(() => clearInterval(checkForInstance), 10000);

		// Expose a function to manually set/get the instance
		window.setVisualPreviewInstance = function (instance) {
			window.currentVisualPreviewInstance = instance;
			console.log("✅ VisualPreviewGenerator instance set manually:", instance);
		};

		window.getVisualPreviewInstance = function () {
			// Try multiple sources
			if (window.currentVisualPreviewInstance) {
				return window.currentVisualPreviewInstance;
			}
			if (
				typeof customCandleBuilder !== "undefined" &&
				customCandleBuilder.visualPreview
			) {
				window.currentVisualPreviewInstance = customCandleBuilder.visualPreview;
				return window.currentVisualPreviewInstance;
			}
			// Try to find from DOM
			const customCandleEl =
				document.querySelector("#custom-candle-interface") ||
				document.querySelector(".custom-candle");
			if (
				customCandleEl &&
				customCandleEl.customCandleInstance &&
				customCandleEl.customCandleInstance.visualPreview
			) {
				window.currentVisualPreviewInstance =
					customCandleEl.customCandleInstance.visualPreview;
				return window.currentVisualPreviewInstance;
			}
			return null;
		};

		// Expose a helper function for manual toggling (useful for debugging)
		window.toggle3DPreview = function (enable) {
			console.log("🔘 toggle3DPreview helper called with enable =", enable);
			const instance = window.getVisualPreviewInstance();
			console.log("🔘 Found instance:", instance);
			console.log(
				"🔘 Instance has toggle3DPreview:",
				!!(instance && typeof instance.toggle3DPreview === "function")
			);

			if (instance && typeof instance.toggle3DPreview === "function") {
				console.log("🔘 Calling instance.toggle3DPreview(" + enable + ")");
				instance.toggle3DPreview(enable);
			} else {
				console.error(
					"❌ Cannot toggle: VisualPreviewGenerator instance not found or missing method"
				);
				console.log("Instance:", instance);
				console.log(
					"window.currentVisualPreviewInstance:",
					window.currentVisualPreviewInstance
				);
				console.log(
					"customCandleBuilder:",
					typeof customCandleBuilder !== "undefined"
						? customCandleBuilder
						: "undefined"
				);
				if (typeof customCandleBuilder !== "undefined") {
					console.log(
						"customCandleBuilder.visualPreview:",
						customCandleBuilder.visualPreview
					);
				}
			}
		};

		// Debug helper to check instance status
		window.check3DPreviewStatus = function () {
			console.log("=== 3D Preview Status ===");
			console.log(
				"window.currentVisualPreviewInstance:",
				window.currentVisualPreviewInstance
			);
			console.log(
				"customCandleBuilder:",
				typeof customCandleBuilder !== "undefined"
					? customCandleBuilder
					: "undefined"
			);
			if (typeof customCandleBuilder !== "undefined") {
				console.log(
					"customCandleBuilder.visualPreview:",
					customCandleBuilder.visualPreview
				);
			}
			console.log("THREE available:", typeof THREE !== "undefined");
			console.log(
				"ThreeDCandlePreview available:",
				typeof ThreeDCandlePreview !== "undefined"
			);
			const instance = window.getVisualPreviewInstance();
			console.log("getVisualPreviewInstance() returns:", instance);
			if (instance) {
				console.log(
					"Instance has toggle3DPreview:",
					typeof instance.toggle3DPreview === "function"
				);
				console.log("Instance is3DMode:", instance.is3DMode);
				console.log("Instance has threeDPreview:", !!instance.threeDPreview);
			}
			console.log("========================");
		};

		console.log("✅ CustomCandle3DPreview module setup complete");

		// After a short delay, check if we need to initialize 3D preview for existing instances
		setTimeout(() => {
			const instance = window.getVisualPreviewInstance();
			if (instance) {
				console.log(
					"🎨 Found existing instance, checking if 3D preview needs initialization"
				);
				// Initialize 3D properties if not already done
				if (instance.threeDPreview === undefined) {
					if (typeof instance.init3DProperties === "function") {
						instance.init3DProperties();
					}
				}
				// If in 3D mode and preview doesn't exist, initialize it
				if (instance.is3DMode === true && !instance.threeDPreview) {
					console.log(
						"🎨 Instance is in 3D mode but preview doesn't exist, initializing..."
					);
					if (typeof instance.waitForThreeJSAndToggle === "function") {
						instance.waitForThreeJSAndToggle();
					}
				}
			}
		}, 500);
	}

	// Start initialization
	initialize3DPreview();
})();
